import { arrowForwardOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { CarAttributes } from '~/shared/api'
import {
  Wrapper,
  ContentWrapper,
  Button,
  ButtonContent,
  IonIcon,
} from './styled'

type CardProps = {
  onStart: () => void
  car: CarAttributes
}

export function Card({ onStart, car }: CardProps) {
  const { t } = useTranslation()

  return (
    <Wrapper onClick={onStart}>
      <ContentWrapper>
        <div style={{ fontSize: '24px' }}>{car.plateNumber}</div>
        <div style={{ fontSize: '14px' }}>{t('software passage')}</div>
      </ContentWrapper>

      <Button data-testid='start-inspection-button'>
        <ButtonContent>
          <IonIcon icon={arrowForwardOutline} />
          {t('button.start')}
        </ButtonContent>
      </Button>
    </Wrapper>
  )
}
